import { useState } from 'react';
import { F1 } from '@client/new/helpers/types';

export type SortingOrder = 'up' | 'down';

export type Sorting<T extends string = string> = {
  setColumn: F1<T | null>;
  column: T | null;
  order: SortingOrder | null;
};

export const useSorting = <T extends string = string>(): Sorting<T> => {
  const [column, _setColumn] = useState<T | null>(null);
  const [order, _setOrder] = useState<null | SortingOrder>(null);
  const setColumn = (name: T | null) => {
    _setOrder(name === column ? (order === 'up' ? 'down' : 'up') : 'up');
    _setColumn(name);
  };
  return { setColumn, column, order };
};
